import { DdsElement } from '../dds-hu-element'
import { FeedbackMixin } from './feedbackMixin'
import { FocusableMixin } from './focusableMixin'
import { FormElementMixin } from './formElementMixin'
import { LabelableMixin } from './labelableMixin'
import { SizedMixin } from './sizedMixin'

export const GenericFormElement = FeedbackMixin(
  FocusableMixin(LabelableMixin(SizedMixin(FormElementMixin(DdsElement)))),
)
